import { OrderSuccess } from "assets/images";
import React from "react";

const OrderPlaced = () => {
  return (
    <div className="customCard orderBlock">
      <div className="orderSuccessful">
        <figure className="success-icon flex justify-center items-center">
          <OrderSuccess aria-hidden="true" focusable="false" />
        </figure>
        <h2>Order Successful</h2>
        <span>Request sent for approval to your administrator</span>
        <p>Upon approval of your order you will receive a confirmation email with the updated delivery date</p>
      </div>
      <div className="form-buttons flex items-center justify-end pt-4"></div>
    </div>
  );
};

export default OrderPlaced;
